// MyToastContainer.tsx
import React from "react";
import { ToastContainer, ToastContainerProps } from "react-toastify";
import styles from "./toast.module.css";

const themeClassMap = {
    light: {
        container: styles.toastContainerLight,
        toast: styles.toastLight,
        body: styles.toastBodyLight,
    },
    dark: {
        container: styles.toastContainerDark,
        toast: styles.toastDark,
        body: styles.toastBodyDark,
    },
};

interface MyToastContainerProps extends ToastContainerProps {
    theme?: "light" | "dark";
}

export function PliiToastContainer({ theme = "light", ...props }: MyToastContainerProps) {
    const classes = themeClassMap[theme];

    return (
        <ToastContainer
            // Default props, which can still be overridden per toast
            position="bottom-center"
            autoClose={4000}
            hideProgressBar
            closeOnClick
            pauseOnHover
            draggable
            closeButton={false}
            className={classes.container}
            toastClassName={classes.toast}
            bodyClassName={classes.body}
            {...props}
        />
    );
}
